import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { joinKeys } from 'helpers/translations.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { createRouteExternalCourse } from 'enum/routes'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { useAccess } from 'contexts/AccessContext'
import UploadCertificatesModal from '../../../../common/UploadCertificatesModal'
import { prefixTranslation } from './common'
import UploadCertificates from './components/UploadCertificates'
import optionStyles from './Options.module.scss'

interface IProps {
  externalCourse: ExternalCourseModelAPI
  onDelete(): void
  onDownload(): void
}

const Options: React.FC<IProps> = ({
  externalCourse,
  onDelete,
  onDownload,
}) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const [uploadCertificates, setUploadCertificates] = useState(false)
  const { can, access } = useAccess()

  const { id } = externalCourse
  const handleDropdownClick = (showDropdown: boolean) => {
    setShow(showDropdown)
  }

  const canPreview = can('manageExternalCourses')
  const canUploadCertificates = can('manageExternalCourses')
  const canDelete = can('manageExternalCourses')
  const canDownload = access.canDownloadReportWithViewAccess()

  const hasVisibleOptions =
    canPreview || canUploadCertificates || canDelete || canDownload

  if (!hasVisibleOptions) {
    return null
  }

  return (
    <>
      <div
        className={show ? optionStyles.menuOpen : undefined}
        data-menu-open={show ? 'true' : undefined}
      >
        <DropdownButton
          show={show}
          disabled={loading}
          className={styles.actionSelect}
          alignRight
          title={<DropdownLoader loading={loading} />}
          onClick={() => handleDropdownClick(!show)}
          onToggle={(nextShow) => handleDropdownClick(nextShow)}
        >
          {canPreview && (
            <Link
              className={styles['option-item']}
              to={createRouteExternalCourse({ id: `${id}` })}
              onClick={() => setShow(false)}
            >
              {t(joinKeys(prefixTranslation, 'preview'))}
            </Link>
          )}
          {canUploadCertificates && (
            <UploadCertificates
              className={styles['option-item']}
              onClick={() => {
                setUploadCertificates(true)
                setShow(false)
              }}
            />
          )}
          {canDelete && (
            <a className={styles['option-item']} onClick={() => onDelete()}>
              {t(joinKeys(prefixTranslation, 'delete'))}
            </a>
          )}
          {canDownload && (
            <a className={styles['option-item']} onClick={() => onDownload()}>
              {t(joinKeys(prefixTranslation, 'downloadDetailedReport'))}
            </a>
          )}
        </DropdownButton>
      </div>
      <UploadCertificatesModal
        show={uploadCertificates}
        externalCourse={externalCourse}
        onClose={() => {
          setUploadCertificates(false)
        }}
      />
    </>
  )
}

export default Options
